module.exports = __webpack_public_path__ + "static/media/celloplay.5a4ade58.JPG";